import { checkStatus } from '../../utilities/fetch';
import {
  autocompleteNewsTopicsPath,
  newsSearchPath,
} from '../../utilities/api_relative_paths';
import {
  GetTopicsResponse,
  GetArticlesResponse,
  ParsedFiltersForApi,
} from '../types/news_search.types';
import { XMLHTTPResponse } from '../../utilities/types';
import { createQueryString } from '../../utilities/utilities';

/**
 * Function to fetch all News Topics
 *
 * @returns {Promise} Promise that can be consumed
 */
const getTopics = (): Promise<GetTopicsResponse> =>
  fetch(autocompleteNewsTopicsPath)
    .then((response: XMLHTTPResponse) => checkStatus(response))
    .then((response) => response.json())
    .catch((error) => Promise.reject(error));

const getArticles = (filters: ParsedFiltersForApi): Promise<GetArticlesResponse> =>
  fetch(newsSearchPath + createQueryString(filters))
    .then(checkStatus)
    .then((response) => response.json())
    .catch((error) => Promise.reject(error));

export { getTopics, getArticles };
